<template>
  <div class="ai-check-container">
    <!-- Header Banner -->
    <div class="ai-header-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <div class="banner-left">
          <div class="ai-icon-pulse">
            <i class="el-icon-files"></i>
          </div>
          <div>
            <h1 class="banner-title">LỊCH SỬ HOẠT ĐỘNG CLOUD (S3)</h1>
            <p class="banner-subtitle">Giám sát và kiểm tra lịch sử ghi nhật ký hoạt động đồng bộ tệp tin, hình ảnh lên nền tảng Amazon S3.</p>
          </div>
        </div>
        <div class="banner-actions flex gap-2">
          <el-button
            type="success"
            class="gradient-btn green-btn"
            icon="el-icon-plus"
            :disabled="dataSearch.delActive === false"
            @click="handleCreateActionCommand"
          >
            Thêm hoạt động mới
          </el-button>
          
          <el-dropdown @command="handleCommand" :disabled="dataSearch.delActive === false" class="modern-dropdown-wrapper">
            <el-button type="warning" class="gradient-btn purple-btn" :disabled="dataSearch.delActive === false">
              Tác vụ gộp <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" class="modern-dropdown-menu">
              <el-dropdown-item command="activeAction" v-if="showAction" icon="el-icon-circle-check">Kích hoạt</el-dropdown-item>
              <el-dropdown-item command="no-activeAction" v-if="showNoAction" icon="el-icon-circle-close">Hủy kích hoạt</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- Quick Stats Grid -->
    <div class="ai-stats-grid">
      <div class="stat-card blue">
        <div class="stat-icon"><i class="el-icon-notebook-1"></i></div>
        <div class="stat-info">
          <p class="stat-label">Tổng hoạt động</p>
          <h3 class="stat-value">{{ totalRecords }}</h3>
        </div>
      </div>
      <div class="stat-card green">
        <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
        <div class="stat-info">
          <p class="stat-label">Đang chạy (trang này)</p>
          <h3 class="stat-value">{{ stats.activeCount }}</h3>
        </div>
      </div>
      <div class="stat-card purple">
        <div class="stat-icon"><i class="el-icon-folder-delete"></i></div>
        <div class="stat-info">
          <p class="stat-label">Đã lưu trữ / Xóa</p>
          <h3 class="stat-value">{{ dataSearch.delActive ? 'Chưa xóa' : 'Đã xóa' }}</h3>
        </div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="glass-card mb-4">
      <el-form :inline="true" :model="dataSearch" class="modern-filter-form">
        <el-form-item label="Trạng thái hoạt động">
          <el-select
            v-model="dataSearch.statusAction"
            clearable
            placeholder="Tất cả trạng thái"
            class="modern-select"
            @change="findAllData"
          >
            <el-option
              v-for="(item, index) in listStatusAction"
              :key="index"
              :value="item.key"
              :label="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Trạng thái lưu trữ">
          <el-select
            v-model="dataSearch.delActive"
            placeholder="Loại lưu trữ"
            class="modern-select"
            @change="findAllData"
          >
            <el-option
              v-for="(item, index) in listDelActive"
              :key="index"
              :value="item.key"
              :label="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Tìm tên hoạt động">
          <el-input
            v-model="dataSearch.nameAction"
            clearable
            placeholder="Nhập tên hoạt động..."
            class="modern-input"
            prefix-icon="el-icon-search"
            @keyup.enter.native="findAllData"
            @clear="findAllData"
          />
        </el-form-item>

        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="findAllData">Lọc dữ liệu</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Table Section -->
    <div class="glass-card table-container">
      <el-table
        :data="listHistoryActionAdmin"
        v-loading="loadingData"
        element-loading-text="Đang tải lịch sử hoạt động S3..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.7)"
        class="modern-table"
        border
        highlight-current-row
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center" />
        
        <el-table-column type="index" :index="calculateStt" label="STT" width="55" align="center" />

        <el-table-column prop="nameAction" label="Tên hoạt động" min-width="220">
          <template slot-scope="{ row }">
            <el-button type="text" class="click-in-row-btn" @click="detailAction(row)">
              <i class="el-icon-folder" style="margin-right: 4px;"></i>
              {{ row.nameAction }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column prop="codeAction" label="Mã hoạt động" min-width="160" align="center">
          <template slot-scope="{ row }">
            <code class="code-badge">{{ row.codeAction }}</code>
          </template>
        </el-table-column>

        <el-table-column label="Trạng thái" width="160" align="center">
          <template slot-scope="{ row }">
            <span class="status-badge" :class="row.statusAction ? 'online' : 'offline'">
              <span class="dot"></span>
              {{ row.statusAction ? 'Đang hoạt động' : 'Ngừng hoạt động' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="typeAction" label="Loại tác vụ" min-width="140" align="center">
          <template slot-scope="{ row }">
            <el-tag type="info" size="medium" effect="plain">{{ row.typeAction }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="Tác vụ" width="280" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" icon="el-icon-time" @click="handleDetail(row)">
              Lịch sử
            </el-button>
            <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              :disabled="row.delActive === false"
              @click="handleUpdate(row)"
            >Sửa
            </el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              :disabled="row.statusAction === true || row.delActive === false"
              @click="handleDelete(row)"
            >Xóa
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination controls -->
      <div class="pagination-wrapper mt-3 flex justify-center">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentPageChange"
          :current-page.sync="dataSearch.page"
          :page-sizes="listSizePage"
          :page-size="dataSearch.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecords"
        >
        </el-pagination>
      </div>
    </div>

    <!-- Dialogs -->
    <CreateHistoryActionDialog
      :listCodeAction="listCodeAction"
      :isCreateHistoryAction="isCreateHistoryAction"
      @close="handleCloseCreateHistoryActionDialog"
    />
    <UpdateHistoryActionDialog
      :idHistory="idHistory"
      :checkUpdate="checkUpdate"
      :isUpdateHistoryAction="isUpdateHistoryAction"
      @close="handleCloseUpdateHistoryActionDialog"
    />
    <DetailHistoryActionDialog
      :isDetailHistoryAction="isDetailHistoryAction"
      :idHistory="idHistory"
      :codeAction="codeAction"
      @close="handleDetailHistoryActionDialog"
    />
  </div>
</template>

<script>
import HistoryActionMaster from "@/services/AdminService/HistoryActionMaster";
import CreateHistoryActionDialog from "@/views/master/other/CreateHistoryActionDialog.vue";
import UpdateHistoryActionDialog from "@/views/master/other/UpdateHistoryActionDialog.vue";
import DetailHistoryActionDialog from "@/views/master/other/DetailHistoryActionDialog.vue";

export default {
  name: "ManageOperationHistoryS3",
  components: { DetailHistoryActionDialog, UpdateHistoryActionDialog, CreateHistoryActionDialog },
  data() {
    return {
      isOpenDesc: false,
      listHistoryActionAdmin: [],
      multipleSelection: [],
      loadingData: true,
      isCreateHistoryAction: false,
      isUpdateHistoryAction: false,
      checkUpdate: false,
      isDetailHistoryAction: false,
      idHistory: 0,
      codeAction: "",
      dataSearch: {
        statusAction: null,
        delActive: true,
        nameAction: "",
        page: 1,
        limit: 25
      },
      showAction: true,
      showNoAction: true,
      listCodeAction: [],
      listStatusAction: [
        { key: true, value: "Đang hoạt động" },
        { key: false, value: "Ngừng hoạt động" }
      ],
      listDelActive: [
        { key: true, value: "Chưa xóa" },
        { key: false, value: "Đã xóa" }
      ],
      listSizePage: [10, 25, 50, 100, 250, 500],
      totalRecords: 0
    };
  },

  computed: {
    stats() {
      let activeCount = 0;
      this.listHistoryActionAdmin.forEach(h => {
        if (h.statusAction) activeCount++;
      });
      return { activeCount };
    }
  },

  created() {
    this.findAllData();
  },

  methods: {
    findAllData() {
      this.loadingData = true;
      HistoryActionMaster.findAllHistoryActionAdmin(
        this.dataSearch.delActive,
        this.dataSearch.statusAction,
        this.dataSearch.nameAction,
        this.dataSearch.page,
        this.dataSearch.limit
      )
        .then((res) => {
          const data = res.data;
          this.listHistoryActionAdmin = data.data.codeActiveResponseList || [];
          this.totalRecords = data.data.total || 0;
        })
        .catch((err) => {
          this.listHistoryActionAdmin = [];
          console.error(err);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    handleCommand(command) {
      if (command === "activeAction") {
        this.handleActiveAction();
      }
      if (command === "no-activeAction") {
        this.handleNoActiveAction();
      }
    },

    handleCreateActionCommand() {
      this.listCodeAction = this.listHistoryActionAdmin.map(h => h.codeAction);
      this.isCreateHistoryAction = true;
    },

    handleActiveAction() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("Vui lòng chọn hoạt động cần kích hoạt!");
        return;
      }
      
      let listId = this.multipleSelection.map(m => m.id);
      this.$confirm("Bạn có chắc chắn muốn kích hoạt đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
        type: "warning"
      }).then(() => {
        HistoryActionMaster.activeHistoryActionAdmin({ listId })
          .then((res) => {
            if (res.data) {
              this.$message.success("Kích hoạt thành công");
              this.findAllData();
            } else {
              this.$message.error("Kích hoạt thất bại");
            }
          })
          .catch((err) => {
            console.error(err);
          });
      });
    },

    handleNoActiveAction() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("Vui lòng chọn hoạt động cần hủy kích hoạt!");
        return;
      }
      
      let listId = this.multipleSelection.map(m => m.id);
      this.$confirm("Bạn có chắc chắn muốn hủy kích hoạt đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
        type: "warning"
      }).then(() => {
        HistoryActionMaster.noActiveHistoryActionAdmin({ listId })
          .then((res) => {
            if (res.data) {
              this.$message.success("Hủy kích hoạt thành công");
              this.findAllData();
            } else {
              this.$message.error("Hủy kích hoạt thất bại");
            }
          })
          .catch((err) => {
            console.error(err);
          });
      });
    },

    handleDetail(row) {
      this.idHistory = row.id;
      this.codeAction = row.codeAction;
      this.isDetailHistoryAction = true;
    },

    handleUpdate(row) {
      this.checkUpdate = true;
      this.idHistory = row.id;
      this.isUpdateHistoryAction = true;
    },

    detailAction(row) {
      this.checkUpdate = false;
      this.idHistory = row.id;
      this.isUpdateHistoryAction = true;
    },

    handleDelete(row) {
      this.$confirm("Bạn có chắc chắn muốn xóa hoạt động đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
        type: "warning"
      }).then(() => {
        HistoryActionMaster.deleteHistoryActionAdmin(row.id)
          .then((res) => {
            if (res.data) {
              this.$message.success("Xóa hoạt động thành công");
              this.findAllData();
            } else {
              this.$message.error("Xóa hoạt động thất bại");
            }
          })
          .catch((err) => {
            console.error(err);
          });
      });
    },

    handleCloseUpdateHistoryActionDialog() {
      this.isUpdateHistoryAction = false;
      this.findAllData();
    },

    handleCloseCreateHistoryActionDialog() {
      this.isCreateHistoryAction = false;
      this.findAllData();
    },

    handleDetailHistoryActionDialog() {
      this.isDetailHistoryAction = false;
      this.findAllData();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      let checkStatusAction = this.multipleSelection.map(m => m.statusAction);
      let trueCount = checkStatusAction.filter(s => s).length;
      let falseCount = checkStatusAction.filter(s => !s).length;

      if (trueCount > 0 && falseCount > 0) {
        this.showAction = false;
        this.showNoAction = false;
      } else if (trueCount > 0 && falseCount === 0) {
        this.showAction = false;
        this.showNoAction = true;
      } else if (trueCount === 0 && falseCount > 0) {
        this.showAction = true;
        this.showNoAction = false;
      } else {
        this.showAction = true;
        this.showNoAction = true;
      }
    },

    handleSizeChange(value) {
      this.dataSearch.limit = value;
      this.dataSearch.page = 1;
      this.findAllData();
    },

    handleCurrentPageChange(value) {
      this.dataSearch.page = value;
      this.findAllData();
    },

    calculateStt(index) {
      return (this.dataSearch.page - 1) * this.dataSearch.limit + index + 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-check-container {
  padding: 16px;
  background-color: #f4f6fa;
  min-height: calc(100vh - 120px);
}

/* Header Banner Styling */
.ai-header-banner {
  position: relative;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 32px;
  margin-bottom: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(30, 60, 114, 0.15);

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  }

  .banner-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    width: 100%;
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .ai-icon-pulse {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
    animation: iconPulse 3s infinite ease-in-out;

    i {
      font-size: 32px;
      color: #fff;
    }
  }

  .banner-title {
    color: #fff;
    font-size: 22px;
    margin: 0 0 6px 0;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .banner-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    margin: 0;
  }

  .banner-actions {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .gradient-btn {
    border: none;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
    }

    &.green-btn {
      background: linear-gradient(90deg, #10b981 0%, #059669 100%);
      box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
      &:hover { box-shadow: 0 6px 15px rgba(16, 185, 129, 0.4); }
    }

    &.purple-btn {
      background: linear-gradient(90deg, #8b5cf6 0%, #6d28d9 100%);
      box-shadow: 0 4px 10px rgba(139, 92, 246, 0.3);
      &:hover { box-shadow: 0 6px 15px rgba(139, 92, 246, 0.4); }
    }
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  }
}

/* Stats Cards Grid */
.ai-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  .stat-info {
    flex: 1;
  }

  .stat-label {
    margin: 0 0 4px 0;
    font-size: 13px;
    color: #64748b;
  }

  .stat-value {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
  }

  /* Colors */
  &.blue {
    border-left: 4px solid #3b82f6;
    .stat-icon { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
  }
  &.green {
    border-left: 4px solid #10b981;
    .stat-icon { background: rgba(16, 185, 129, 0.1); color: #10b981; }
  }
  &.purple {
    border-left: 4px solid #8b5cf6;
    .stat-icon { background: rgba(139, 92, 246, 0.1); color: #8b5cf6; }
  }
}

/* Glassmorphic Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.table-container {
  background: #fff;
  padding: 12px;
}

/* Filter Forms */
.modern-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  .modern-select {
    width: 175px;
  }
  
  .modern-input {
    width: 245px;
  }
}

/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 48px;
  }

  /deep/ td {
    padding: 10px 0;
  }
}

.click-in-row-btn {
  font-weight: 600;
  color: #3b82f6;
  font-size: 14px;
  padding: 0;
  &:hover {
    color: #1d4ed8;
    text-decoration: underline;
  }
}

.code-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  color: #64748b;
  border: 1px solid #cbd5e1;
}

/* Status Badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 9999px;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  &.online {
    background-color: #f0fdf4;
    color: #166534;
    .dot {
      background-color: #22c55e;
      box-shadow: 0 0 8px #22c55e;
      animation: pulseGreen 2s infinite;
    }
  }

  &.offline {
    background-color: #fef2f2;
    color: #991b1b;
    .dot {
      background-color: #ef4444;
    }
  }
}

@keyframes pulseGreen {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

/* Dropdown styling */
.modern-dropdown-wrapper {
  display: inline-block;
}

.modern-dropdown-menu {
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  border: 1px solid #e2e8f0;
  
  /deep/ .el-dropdown-menu__item {
    font-weight: 600;
    font-size: 13px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #475569;

    i {
      font-size: 16px;
    }

    &:hover {
      background-color: #f1f5f9;
      color: #3b82f6;
    }
  }
}

.flex {
  display: flex;
}
.gap-2 {
  gap: 8px;
}
</style>